module.exports = __webpack_public_path__ + "static/media/notification.0b4ac1dc.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/notification.ttf
// module id = 153
// module chunks = 0